<!--
 * @file: 学习中心页面左侧菜单组件
 * @Author: 小白
 -->
<template>
  <div class="main">
    <div class="layout-w">
      <div class="left-main">
        <div
          v-for="(typeItem, typeIndex) in state.menuList"
          :key="typeIndex"
          class="father-box"
        >
          <div class="father-title-box">
            {{ typeItem.title }}
          </div>
          <div
            v-for="(childItems, childIndexs) in typeItem.children"
            :key="childIndexs"
            class="child-box"
            :class="{
              active: state.pathname == childItems.path,
            }"
          >
            <router-link :to="{ path: childItems.path }" style="width: 100%">
              <div class="child-title-box">
                <a-badge :dot="childItems.dot" :count="childItems.noticeNum">
                  <icon-font
                    class="child-icon"
                    :type="
                      state.pathname == childItems.path
                        ? childItems.active
                        : childItems.icon
                    "
                  />
                  <span
                    :class="{
                      active: state.pathname == childItems.path,
                    }"
                  >
                    {{ childItems.title }}
                  </span>
                </a-badge>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="right-main">
        <router-view />
      </div>
    </div>
  </div>
  <div class="header-fixed">
    <div class="nav-style-one">
      <div class="nav-box-logo c-085 flex-center cp border-none">
        <img
          src="https://huahanonlineppt.oss-cn-shenzhen.aliyuncs.com/smuImage/web/logo.jpg"
          alt=""
        />
      </div>
      <a-popover
        style="display: flex"
        placement="bottom"
        :title="null"
        overlay-class-name="nav-top"
        :arrow-point-at-center="true"
        :get-popup-container="(trigger) => trigger.parentNode"
      >
        <template #content>
          <div class="user-popover">
            <div v-for="(items, index) in state.userMenuList" :key="index">
              <div class="user-popover-item" @click="bgRouter(items)">
                <icon-font class="upi-icon" :type="items.icon" />
                <div class="upi-text">
                  {{ items.name }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="user-img flex-height-center">
          <div class="nav-user-image flex-center">
            <icon-font type="icon-morentouxiang" class="header-user-img" />
          </div>
        </div>
        <div class="user-name flex-height-center">
          <span class="name">{{ `${state.user.userName}` }}</span>
        </div>
      </a-popover>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import store from "@/store";
import { loginOut, updateUserInfo } from "@/utils/function.js";
import { getStudentNotification } from "@/api/user.js";
import { queryUnread } from "@/api/notification.js";
import { logOut } from "@/api/login.js";

const route = useRoute();

const state = reactive({
  user: "",
  pathname: "",
  userMenuList: [
    // {
    //   icon: "icon-xuexizhongxin",
    //   name: "学习中心",
    //   path: "/member",
    // },
    // {
    //   icon: "icon-zhibo3",
    //   name: "我的直播",
    //   path: "/member/live",
    // },
    {
      icon: "icon-tuichu",
      name: "退出登录",
      path: "loginOut",
    },
  ],
  menuList: [
    {
      title: "学习中心",
      children: [
        {
          title: "我的课程",
          icon: "icon-Project",
          active: "icon-Project-active",
          path: "/myCenter/courseList",
        },
        {
          title: "我的直播",
          icon: "icon-wodezhibo",
          active: "icon-wodezhibo-active",
          path: "/myCenter/liveList",
        },
        {
          title: "我的提问",
          icon: "icon-wodetiwen",
          active: "icon-wodetiwen-active",
          path: "/myCenter/ask",
        },
        {
          title: "我的错题",
          icon: "icon-wodecuoti",
          active: "icon-wodecuoti-active",
          path: "/myCenter/error",
        },
        {
          title: "学习进度",
          icon: "icon-Subject",
          active: "icon-Subject-active",
          path: "/myCenter/progress",
        },
      ],
    },
    {
      title: "个人中心",
      children: [
        {
          title: "学籍信息",
          icon: "icon-xueshuxinxi",
          active: "icon-xueshuxinxi-active",
          path: "/myCenter/schoolRoll",
        },
        {
          title: "考试管理",
          icon: "icon-kaoshiguanli",
          active: "icon-kaoshiguanli-active",
          path: "/myCenter/testManage",
        },
        {
          title: "论文管理",
          icon: "icon-lunwenguanli",
          active: "icon-lunwenguanli-active",
          path: "/myCenter/paperManage",
          dot: false,
        },
        {
          title: "学位申请",
          icon: "icon-xueweishenqing",
          active: "icon-xueweishenqing-active",
          path: "/myCenter/degreeApply",
          dot: false,
        },
        {
          title: "毕业申请",
          icon: "icon-biyeshenqing",
          active: "icon-biyeshenqing-active",
          path: "/myCenter/graduateApply",
          dot: false,
        },
        {
          title: "我的协议",
          icon: "icon-wodexieyi",
          active: "icon-wodexieyi-active",
          path: "/myCenter/myAgreement",
        },
        {
          title: "缴费订单",
          icon: "icon-wodefeiyong",
          active: "icon-wodefeiyong-active",
          path: "/myCenter/paymentOrder",
        },
        {
          title: "消息通知",
          icon: "icon-xiaoxitongzhi",
          active: "icon-xiaoxitongzhi-active",
          path: "/myCenter/notification",
          type: "notification",
          noticeNum: 0,
        },
        {
          title: "设置",
          icon: "icon-shezhi",
          active: "icon-shezhi-active",
          path: "/myCenter/setUp",
        },
      ],
    },
  ],
});

const bgRouter = (item) => {
  switch (item.path) {
    case "loginOut":
      logOut().then(() => {
        loginOut();
      });
      break;
  }
};

onMounted(() => {
  updateUserInfo().then(() => {
    state.user = JSON.parse(localStorage.getItem("userInfo"));
    getUnRead();
  });
});

// 获取未读标记
const getUnRead = () => {
  queryUnread().then((res) => {
    const couponIndex = state.menuList[1].children.findIndex(
      (item) => item.type === "notification"
    );
    state.menuList[1].children[couponIndex].noticeNum = res.queryUnread;
  });

  getStudentNotification().then((res) => {
    const graduateApplyIndex = state.menuList[1].children.findIndex(
      (item) => item.type === "graduateApply"
    );
    const paperManageIndex = state.menuList[1].children.findIndex(
      (item) => item.type === "paperManage"
    );
    if (res.includes("PAPER") && paperManageIndex != -1) {
      state.menuList[1].children[paperManageIndex].dot = true;
    }
    if (res.includes("GRADUATION") && graduateApplyIndex != -1) {
      state.menuList[1].children[graduateApplyIndex].dot = true;
    }
  });
};

watch(
  () => store.getters.notification,
  (val) => {
    if (val) {
      store.commit("cachedView/SET_NOTIFICATION_STAGE", false);
      getUnRead();
    }
  },
  {
    immediate: true,
    deep: true,
  }
);

watch(
  () => route.path,
  () => {
    state.pathname = route.path;
  },
  {
    immediate: true,
  }
);
</script>

<style>
.nav-top .ant-popover-inner-content {
  padding: 12px 0;
}
</style>

<style lang="scss" scoped>
@import "@/style/var.scss";
.main {
  padding-top: 120px;
  flex-wrap: wrap;
  flex-direction: column;
  background: #f6f7f9;
  height: 100%;
  min-height: 100vh;
}
.left-main {
  width: 180px;
  min-height: calc(100vh - 144px);
  padding-bottom: 40px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.04);
  .father-box {
    padding-top: 6px;
    .father-title-box {
      padding-left: 20px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: $color-45;
      font-weight: 700;
    }
  }
}
.right-main {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: calc(1200px - 204px);
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.04);
}
.child-box {
  padding-left: 20px;
  margin-bottom: 6px;
  cursor: pointer;
  @include flex-height-center;
  &:last-child {
    margin-bottom: 0;
  }
  .child-title-box {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    span {
      color: $color-85;
    }
    .active {
      color: $primary-color;
    }
    @include flex-height-center;
    .child-icon {
      font-size: 24px;
      margin-right: 6px;
      vertical-align: middle;
    }
  }
}
.child-box.active {
  background: #f3f6ff;
  border-right: 3px solid $primary-color;
}

.nav-style-one {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .nav-box-logo {
    width: 180px;
    height: 50px;
    font-size: 18px;
    border: 1px dashed #dedede;
    transition: all 0.4s ease-in-out 0s;
    a {
      width: 100%;
      height: 100%;
    }
    img {
      height: 100%;
      object-fit: contain;
    }
  }
  .border-none {
    border: none;
  }
  .nav-user-image {
    width: 36px;
    height: 36px;
    background: #e3e3e3;
    border-radius: 50%;

    .header-user-img {
      width: 100%;
      height: 100%;
      color: #c4c4c4;
    }
  }
}
.header-fixed {
  position: fixed;
  z-index: 99;
  top: 0;
  width: 100%;
  height: 62px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.14);
  .nav-style-one {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    align-items: center;
  }
  .user-img,
  .user-name {
    display: inline-block;
    vertical-align: middle;
    margin: 0 16px;
  }
}
.user-popover {
  min-width: 160px;
  .user-popover-item {
    display: flex;
    align-items: center;
    padding: 0 16px;
    min-height: 38px;
    line-height: 38px;
    cursor: pointer;
    // @include flex-height-center;
    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
  }
  .upi-icon {
    margin-right: 10px;
    font-size: 20px;
    color: rgba($color: #000000, $alpha: 0.45);
  }
  .upi-text {
    font-size: 16px;
    color: rgba($color: #000000, $alpha: 0.65);
  }
}
</style>
